// Authentic brand assets, bundled in /public/brand for production reliability.
// Official PropertyConnect brand (navy + gold PC City mark, tagline CONNECT • MATCH • CLOSE).
export const PC_LOGO_FULL = "/brand/pc-logo-official.webp"; // full horizontal lockup (emblem + wordmark + tagline)
export const PC_MARK = "/brand/pc-emblem-official.png";     // Connected PC City emblem for navbar/splash
export const LOGO_URL = "/brand/logo.png";
export const MONOGRAM_URL = "/brand/monogram.png";
export const FOUNDER_URL = "/brand/founder.jpg";
export const BOOK_WYTYM_URL = "/brand/book-wytym.jpg";
export const BOOK_WSM_URL = "/brand/book-wsm.jpg";
